var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStarBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 5.5,
    fill: "#008A94"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 11,
    height: 11,
    rx: 5.5,
    stroke: "#007078"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00806 2.57373C5.97551 2.57373 5.94295 2.59001 5.92668 2.62256L4.90124 4.706C4.88496 4.75483 4.83613 4.78738 4.77102 4.78738L2.49226 5.12919C2.42716 5.14547 2.3946 5.22686 2.44343 5.27569L4.10367 6.90337C4.13622 6.93592 4.1525 7.00103 4.1525 7.04986L3.76186 9.32862C3.74558 9.37745 3.79441 9.42628 3.84324 9.42628C3.85952 9.42628 3.87579 9.42628 3.87579 9.41L5.92668 8.33573C5.97551 8.30318 6.02434 8.30318 6.07317 8.33573L8.12405 9.39373C8.14033 9.39373 8.1566 9.41 8.1566 9.41C8.20543 9.41 8.25426 9.36117 8.23799 9.31234L7.84734 7.03358C7.83107 6.98475 7.86362 6.91965 7.89617 6.88709L9.55641 5.25941C9.60524 5.21058 9.57269 5.12919 9.50758 5.11292L7.21255 4.7711C7.16372 4.7711 7.11489 4.72227 7.08233 4.68972L6.08944 2.62256C6.07317 2.59001 6.04061 2.57373 6.00806 2.57373Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarBadge);
export default __webpack_public_path__ + "static/media/star-badge.d98a292bf01486e93b09348bcaa8092c.svg";
export { ForwardRef as ReactComponent };